export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6586.afb9deee.jpg";